module.exports = __webpack_public_path__ + "static/media/newUserCorp.1439d999.svg";